import Vue from "vue";
import Vuetify from "vuetify";

export const vuetifyOptions = {
  iconfont: "md",
  rtl: true,
};

Vue.use(Vuetify);
